/* tslint:disable */
/* eslint-disable */
/**
 * CipherMail back-end API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { PGPTrustListResult } from '../model';
// @ts-ignore
import type { PGPTrustListStatus } from '../model';
/**
 * PGPTrustListApi - axios parameter creator
 * @export
 */
export const PGPTrustListApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} sha256Fingerprint 
         * @param {boolean} [includeSubkeys] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pGPTrustListControllerDeletePGPTrustListEntry: async (sha256Fingerprint: string, includeSubkeys?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sha256Fingerprint' is not null or undefined
            assertParamExists('pGPTrustListControllerDeletePGPTrustListEntry', 'sha256Fingerprint', sha256Fingerprint)
            const localVarPath = `/api/pgp/trustlist/deletePGPTrustListEntry`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            if (sha256Fingerprint !== undefined) {
                localVarQueryParameter['sha256Fingerprint'] = sha256Fingerprint;
            }

            if (includeSubkeys !== undefined) {
                localVarQueryParameter['includeSubkeys'] = includeSubkeys;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pGPTrustListControllerGetPGPTrustListCount: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/pgp/trustlist/getPGPTrustListCount`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [firstResult] 
         * @param {number} [maxResults] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pGPTrustListControllerGetPGPTrustListEntries: async (firstResult?: number, maxResults?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/pgp/trustlist/getPGPTrustListEntries`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            if (firstResult !== undefined) {
                localVarQueryParameter['firstResult'] = firstResult;
            }

            if (maxResults !== undefined) {
                localVarQueryParameter['maxResults'] = maxResults;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} sha256Fingerprint 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pGPTrustListControllerGetPGPTrustListEntry: async (sha256Fingerprint: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sha256Fingerprint' is not null or undefined
            assertParamExists('pGPTrustListControllerGetPGPTrustListEntry', 'sha256Fingerprint', sha256Fingerprint)
            const localVarPath = `/api/pgp/trustlist/getPGPTrustListEntry`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            if (sha256Fingerprint !== undefined) {
                localVarQueryParameter['sha256Fingerprint'] = sha256Fingerprint;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {PGPTrustListStatus} status 
         * @param {Array<string>} requestBody 
         * @param {boolean} [includeSubkeys] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pGPTrustListControllerSetPGPTrustListEntries: async (status: PGPTrustListStatus, requestBody: Array<string>, includeSubkeys?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'status' is not null or undefined
            assertParamExists('pGPTrustListControllerSetPGPTrustListEntries', 'status', status)
            // verify required parameter 'requestBody' is not null or undefined
            assertParamExists('pGPTrustListControllerSetPGPTrustListEntries', 'requestBody', requestBody)
            const localVarPath = `/api/pgp/trustlist/setPGPTrustListEntries`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (includeSubkeys !== undefined) {
                localVarQueryParameter['includeSubkeys'] = includeSubkeys;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} sha256Fingerprint 
         * @param {PGPTrustListStatus} status 
         * @param {boolean} [includeSubkeys] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pGPTrustListControllerSetPGPTrustListEntry: async (sha256Fingerprint: string, status: PGPTrustListStatus, includeSubkeys?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sha256Fingerprint' is not null or undefined
            assertParamExists('pGPTrustListControllerSetPGPTrustListEntry', 'sha256Fingerprint', sha256Fingerprint)
            // verify required parameter 'status' is not null or undefined
            assertParamExists('pGPTrustListControllerSetPGPTrustListEntry', 'status', status)
            const localVarPath = `/api/pgp/trustlist/setPGPTrustListEntry`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            if (sha256Fingerprint !== undefined) {
                localVarQueryParameter['sha256Fingerprint'] = sha256Fingerprint;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (includeSubkeys !== undefined) {
                localVarQueryParameter['includeSubkeys'] = includeSubkeys;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PGPTrustListApi - functional programming interface
 * @export
 */
export const PGPTrustListApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PGPTrustListApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} sha256Fingerprint 
         * @param {boolean} [includeSubkeys] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pGPTrustListControllerDeletePGPTrustListEntry(sha256Fingerprint: string, includeSubkeys?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pGPTrustListControllerDeletePGPTrustListEntry(sha256Fingerprint, includeSubkeys, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PGPTrustListApi.pGPTrustListControllerDeletePGPTrustListEntry']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pGPTrustListControllerGetPGPTrustListCount(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pGPTrustListControllerGetPGPTrustListCount(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PGPTrustListApi.pGPTrustListControllerGetPGPTrustListCount']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} [firstResult] 
         * @param {number} [maxResults] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pGPTrustListControllerGetPGPTrustListEntries(firstResult?: number, maxResults?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PGPTrustListResult>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pGPTrustListControllerGetPGPTrustListEntries(firstResult, maxResults, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PGPTrustListApi.pGPTrustListControllerGetPGPTrustListEntries']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} sha256Fingerprint 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pGPTrustListControllerGetPGPTrustListEntry(sha256Fingerprint: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PGPTrustListResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pGPTrustListControllerGetPGPTrustListEntry(sha256Fingerprint, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PGPTrustListApi.pGPTrustListControllerGetPGPTrustListEntry']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {PGPTrustListStatus} status 
         * @param {Array<string>} requestBody 
         * @param {boolean} [includeSubkeys] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pGPTrustListControllerSetPGPTrustListEntries(status: PGPTrustListStatus, requestBody: Array<string>, includeSubkeys?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pGPTrustListControllerSetPGPTrustListEntries(status, requestBody, includeSubkeys, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PGPTrustListApi.pGPTrustListControllerSetPGPTrustListEntries']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} sha256Fingerprint 
         * @param {PGPTrustListStatus} status 
         * @param {boolean} [includeSubkeys] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pGPTrustListControllerSetPGPTrustListEntry(sha256Fingerprint: string, status: PGPTrustListStatus, includeSubkeys?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pGPTrustListControllerSetPGPTrustListEntry(sha256Fingerprint, status, includeSubkeys, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PGPTrustListApi.pGPTrustListControllerSetPGPTrustListEntry']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PGPTrustListApi - factory interface
 * @export
 */
export const PGPTrustListApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PGPTrustListApiFp(configuration)
    return {
        /**
         * 
         * @param {string} sha256Fingerprint 
         * @param {boolean} [includeSubkeys] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pGPTrustListControllerDeletePGPTrustListEntry(sha256Fingerprint: string, includeSubkeys?: boolean, options?: any): AxiosPromise<void> {
            return localVarFp.pGPTrustListControllerDeletePGPTrustListEntry(sha256Fingerprint, includeSubkeys, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pGPTrustListControllerGetPGPTrustListCount(options?: any): AxiosPromise<number> {
            return localVarFp.pGPTrustListControllerGetPGPTrustListCount(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [firstResult] 
         * @param {number} [maxResults] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pGPTrustListControllerGetPGPTrustListEntries(firstResult?: number, maxResults?: number, options?: any): AxiosPromise<Array<PGPTrustListResult>> {
            return localVarFp.pGPTrustListControllerGetPGPTrustListEntries(firstResult, maxResults, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} sha256Fingerprint 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pGPTrustListControllerGetPGPTrustListEntry(sha256Fingerprint: string, options?: any): AxiosPromise<PGPTrustListResult> {
            return localVarFp.pGPTrustListControllerGetPGPTrustListEntry(sha256Fingerprint, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PGPTrustListStatus} status 
         * @param {Array<string>} requestBody 
         * @param {boolean} [includeSubkeys] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pGPTrustListControllerSetPGPTrustListEntries(status: PGPTrustListStatus, requestBody: Array<string>, includeSubkeys?: boolean, options?: any): AxiosPromise<void> {
            return localVarFp.pGPTrustListControllerSetPGPTrustListEntries(status, requestBody, includeSubkeys, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} sha256Fingerprint 
         * @param {PGPTrustListStatus} status 
         * @param {boolean} [includeSubkeys] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pGPTrustListControllerSetPGPTrustListEntry(sha256Fingerprint: string, status: PGPTrustListStatus, includeSubkeys?: boolean, options?: any): AxiosPromise<void> {
            return localVarFp.pGPTrustListControllerSetPGPTrustListEntry(sha256Fingerprint, status, includeSubkeys, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PGPTrustListApi - object-oriented interface
 * @export
 * @class PGPTrustListApi
 * @extends {BaseAPI}
 */
export class PGPTrustListApi extends BaseAPI {
    /**
     * 
     * @param {string} sha256Fingerprint 
     * @param {boolean} [includeSubkeys] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PGPTrustListApi
     */
    public pGPTrustListControllerDeletePGPTrustListEntry(sha256Fingerprint: string, includeSubkeys?: boolean, options?: RawAxiosRequestConfig) {
        return PGPTrustListApiFp(this.configuration).pGPTrustListControllerDeletePGPTrustListEntry(sha256Fingerprint, includeSubkeys, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PGPTrustListApi
     */
    public pGPTrustListControllerGetPGPTrustListCount(options?: RawAxiosRequestConfig) {
        return PGPTrustListApiFp(this.configuration).pGPTrustListControllerGetPGPTrustListCount(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [firstResult] 
     * @param {number} [maxResults] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PGPTrustListApi
     */
    public pGPTrustListControllerGetPGPTrustListEntries(firstResult?: number, maxResults?: number, options?: RawAxiosRequestConfig) {
        return PGPTrustListApiFp(this.configuration).pGPTrustListControllerGetPGPTrustListEntries(firstResult, maxResults, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} sha256Fingerprint 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PGPTrustListApi
     */
    public pGPTrustListControllerGetPGPTrustListEntry(sha256Fingerprint: string, options?: RawAxiosRequestConfig) {
        return PGPTrustListApiFp(this.configuration).pGPTrustListControllerGetPGPTrustListEntry(sha256Fingerprint, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PGPTrustListStatus} status 
     * @param {Array<string>} requestBody 
     * @param {boolean} [includeSubkeys] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PGPTrustListApi
     */
    public pGPTrustListControllerSetPGPTrustListEntries(status: PGPTrustListStatus, requestBody: Array<string>, includeSubkeys?: boolean, options?: RawAxiosRequestConfig) {
        return PGPTrustListApiFp(this.configuration).pGPTrustListControllerSetPGPTrustListEntries(status, requestBody, includeSubkeys, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} sha256Fingerprint 
     * @param {PGPTrustListStatus} status 
     * @param {boolean} [includeSubkeys] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PGPTrustListApi
     */
    public pGPTrustListControllerSetPGPTrustListEntry(sha256Fingerprint: string, status: PGPTrustListStatus, includeSubkeys?: boolean, options?: RawAxiosRequestConfig) {
        return PGPTrustListApiFp(this.configuration).pGPTrustListControllerSetPGPTrustListEntry(sha256Fingerprint, status, includeSubkeys, options).then((request) => request(this.axios, this.basePath));
    }
}

